import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { getFuid } from '../../util';

class Upload extends React.Component {

	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e) {	
		const files = [];
		for (let i=0; i<e.target.files.length; i++) {
			const file = e.target.files[i];
			files.push(file);
		}
		this.props.setFiles(files);
	}

	render() {

		const uid = getFuid();

		let label = <label className="label-file" htmlFor={`upload-${uid}`}>
				<FontAwesomeIcon icon="paperclip" />
			</label>;

		if(this.props.button) {	
			label = <label className="button" htmlFor={`upload-${uid}`}>
				<FontAwesomeIcon icon="paperclip" className="fa-inline" /> Datei anhängen
			</label>
		}

		return (
			<React.Fragment>
				{label}
				<input id={`upload-${uid}`} type="file" hidden onChange={this.handleChange} />
			</React.Fragment>
		);
	}
}

export default Upload


// WEBPACK FOOTER //
// ./src/components/upload/Upload.js